<div class="cpcontent">
    <h2>Backend Tester</h2>
    <button class="btn btn-primary" (click)="startTest()">Start</button>
    <br>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Controller</th>
                <th>Action</th>
                <th>Test</th>
                <th>Result</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let r of testlog">
                <td> {{r.controller}}</td>
                <td> {{r.action}}</td>
                <td> {{r.test}}</td>
                <td><span (click)="r.show = !r.show">+/-</span><pre *ngIf="r.show">{{r.result | json}}</pre></td>
            </tr>
        </tbody>
    </table>

</div>